import { Inject, Injectable, Optional } from '@angular/core';
import { Store } from '@ngxs/store';
import { SimpleRouterState, TranslationId } from '@platform-frontend/util';
import { Observable, map } from 'rxjs';
import { AuthenticationServiceToken, IAuthenticationService } from './account-services';
import { FALLBACK_ACCOUNT_CUSTOMIZED_TEXTS } from './fallback-account-customized-texts';

@Injectable({
  providedIn: 'root'
})
export class AccountTitleService {
  constructor(@Inject(AuthenticationServiceToken) @Optional() private authenticationService: IAuthenticationService | null, private store: Store) {}

  getTitle(): Observable<TranslationId | undefined> {
    return this.store
      .select(SimpleRouterState.data)
      .pipe(map(data => (data.isSignInPage ? this.getSignInPageTitleConfig() : (data.titleConfig as TranslationId | undefined))));
  }

  private getSignInPageTitleConfig(): TranslationId {
    return (
      this.authenticationService?.getAccountCustomizedTexts()?.signIn?.title?.(this.store) ??
      FALLBACK_ACCOUNT_CUSTOMIZED_TEXTS('pureSignIn').signIn.title(this.store)
    );
  }
}
